import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import createTheme from "../theme";
import { useSelector } from "react-redux";

const ThemeWrapper = ({ children }) => {
  const isDarkMode = useSelector((state) => state.settings.isDarkMode);

  const breakpoints = createBreakpoints({});
  const { theme } = createTheme(breakpoints, !!isDarkMode);
  const muiTheme = createMuiTheme({
    ...theme,
    typography: {
      ...(theme.typography || {}),
      fontFamily: "'Inter', 'Roboto', sans-serif",
    },
  });

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

ThemeWrapper.propTypes = {
  children: PropTypes.node,
};

export default ThemeWrapper;
